import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  loginRequest: ['email', 'password', 'history'],
  loginSuccess: ['session'],
  loginFailure: ['error'],
  getSessionRequest: null,
  getSessionSuccess: ['session'],
  getSessionFailure: ['error'],
  emailChanged: ['email'],
  passwordChanged: ['password'],
  logoutRequest: [],
  logoutSuccess: null,
  setLastActiveTime: ['lastActiveTime'],
});

export const LoginTypes = Types;
export default Creators;



// WEBPACK FOOTER //
// ./src/state/actions/LoginActions.js